import { useQuery } from 'react-query';
import { api } from 'src/api/axios';

export const useListSelectAcrylicPlate = () =>
  useQuery(['listSelectAcrylicPlate'], async () => {
    const res = await api.get('/api/cms/template-design/list-acrylic-plate');
    return res.data.data;
  });
